import { Colorpicker, ColorpickerEvents } from "@dhx/ts-colorpicker";
import { el } from "@dhx/ts-common/dom";
import { validate } from "../validate";
import { getIcon } from "./../../configs/icons";
import { getIconGroup, getSelect } from "./helpers";
import { Text } from "./Text";
import { Popup } from "@dhx/ts-popup";

export class Stroke extends Text {
	private _colorPicker: any;
	private _popup: Popup;

	constructor(config, ev) {
		config.validation = config.validation || "color";
		super(config, ev);
		this._colorPicker = new Colorpicker(null);
		this._popup = new Popup();
		this._popup.attach(this._colorPicker);
		this._colorPicker.events.on(ColorpickerEvents.change, stroke => {
			this._popup.hide();
			if (this._config.value.stroke !== stroke) {
				this.setValue({ ...this._config.value, stroke });
			}
		});
		this._handlers.show = e => this._showPopup(e.target);
		this._handlers.saveType = (id, val) => {
			this.setValue({ ...this._config.value, [id]: val });
		};
		this._handlers.change = e => {
			const name = e.target.getAttribute("name");
			const val = e.target.value;
			if (validate(val, "number")) {
				e.target.setAttribute("class", "");
				this.setValue({ ...this._config.value, [name]: val });
			} else {
				e.target.setAttribute("class", "dhx_invalid");
			}
		};
		this._handlers.iconClick = (id, e) => {
			const val = e.target.getAttribute("dhx_id");
			this.setValue({ ...this._config.value, [id]: val });
		};
	}
	toVDOM() {
		const centaral = this._config.value.toSide === "center" || this._config.value.fromSide === "center";

		return el(".edit-section.line-edit", { _key: this._uid }, [
			el(".section-title", this._config.label || ""),
			el(".line-edit-content", [
				el(
					".input_element.alone_picker",
					{
						onclick: this._handlers.show,
					},
					[
						el(".input_icon_wrap", [
							el(".input_icon", {
								style: {
									backgroundColor: this._config.value.stroke,
								},
							}),
						]),
					]
				),
				el(
					".dropup.input_element",
					getSelect(
						this._handlers.saveType,
						"strokeType",
						[
							{ id: "none", text: "None", disabled: this._config.connector },
							{ id: "line", class: "dhx_select_line" },
							{ id: "dash", class: "dhx_select_dash" },
						],
						this._config.value.strokeType || "line"
					)
				),
				this._config.value.strokeType !== "none" &&
					el(".input_element.line_width", [
						el("input", {
							type: "text",
							onchange: this._handlers.change,
							oninput: this._handlers.change,
							_ref: this._uid,
							value: this._config.value.strokeWidth,
							name: "strokeWidth",
							class: this._config.invalid ? "dhx_invalid" : "",
						}),
						el(".title", "PX"),
					]),
			]),
			!centaral &&
				this._config.connector &&
				el(".line-edit-content", [
					el(
						".input_element.arrow_select",
						getSelect(
							this._handlers.saveType,
							"backArrow",
							[
								{ id: "", el: () => getIcon("line") },
								{ id: "filled", el: () => getIcon("filled-arrow") },
							],
							this._config.value.backArrow
						)
					),
					el(
						".input_element.arrow_select",
						getSelect(
							this._handlers.saveType,
							"forwardArrow",
							[
								{ id: "", el: () => getIcon("line") },
								{ id: "filled", el: () => getIcon("filled-arrow-rewerse") },
							],
							this._config.value.forwardArrow
						)
					),
					getIconGroup(
						this._handlers.iconClick,
						"connectType",
						[
							{ id: "straight", el: getIcon("straight"), css: "dhx_line_icon" },
							// [todo]
							// { id: "flex"", el: getIcon("flex""), css: "dhx_line_icon" },
							{ id: "elbow", el: getIcon("elbow"), css: "dhx_line_icon" },
						],
						this._config.value.connectType
					),
				]),
			!centaral &&
				this._config.value.connectType &&
				this._config.value.connectType === "elbow" &&
				el(".input_element", [
					el("input", {
						type: "text",
						name: "cornersRadius",
						onchange: this._handlers.change,
						oninput: this._handlers.change,
						value: this._config.value.cornersRadius,
					}),
					el(".input_icon_wrap", [el(".input_icon", "r")]),
				]),
		]);
	}
	private _showPopup(node: any) {
		this._colorPicker.setValue(this._config.value.stroke);
		this._popup.show(node);
	}
}
